'use client';
import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/customercenter-ui/components/ui/accordion';
import SimilarItems from './similarItems';

interface SimilarItemsListCarouselProps {
  title?: any;
  siteId?: string;
  maxSimilarProductsPerPage?: number;
  objectId?: any;
  data: any;
}

export const SimilarItemsListCarousel: React.FC<SimilarItemsListCarouselProps> = ({
  title,
  siteId,
  maxSimilarProductsPerPage,
  objectId,
  data,
}) => {
  const [isLoading, setIsLoading] = useState(true); // State to track loading status
  const [productAvailable, setProductAvailability] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isProductsHave, setProductsHave] = useState(false);
  const setProductsStatus = (productAvailability: boolean) => {
    setIsLoading(false);
    setProductAvailability(productAvailability);
  };
  const isMailOrderProduct = usePathname().toString().includes('999999');
  if (isMailOrderProduct) {
    return <></>;
  }

  return (
    <section
      className={`max-w-screen-9xl relative  ${
        !isLoading && productAvailable ? 'mx-auto px-4 md:px-[60px]' : 'h-0 overflow-hidden'
      }`}
    >
      <section className="mx-auto max-w-[1390px]">
        <section className="relative w-[1016px]">
          <section className="mb-5 flex items-center justify-between">
            <Accordion type="single" collapsible className="w-full" defaultValue="item-1">
              <AccordionItem value="item-1" className="border-0">
                <AccordionTrigger className="border-b text-lg font-bold leading-6">
                  <strong className="text-2xl font-bold leading-8 text-black">{title}</strong>
                </AccordionTrigger>
                <AccordionContent className="pt-4">
                  <SimilarItems
                    siteId={siteId}
                    maxSimilarProductsPerPage={maxSimilarProductsPerPage}
                    objectId={objectId}
                    setProductsStatus={setProductsStatus}
                    setProductsHave={setProductsHave}
                    data={data}
                  />
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </section>
        </section>
      </section>
    </section>
  );
};

export default SimilarItemsListCarousel;
